<template>
  <TextField
    inputId="fp-system-key"
    name="freedompay.badge_pay_system_key"
    :label="t('sites.singleSite.financialConfig.cashlessPay.form.freedomPay.systemKey')"
    :placeholder="
      t('sites.singleSite.financialConfig.cashlessPay.form.freedomPay.systemKeyPlaceholder')
    "
    :required="editCashlessPay"
    :disabled="!editCashlessPay"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);
</script>
